import JSZip from 'jszip';
import { toJpeg, toPng, toSvg } from 'html-to-image';
import yaml from 'js-yaml';

export const exportGraphAndWorkflow = async (
  workflowData: object,
  fileExt: string = 'json',
  fileName: string = 'workflow-export'
) => {
  const zip = new JSZip();

  // 1. Capture React Flow graph
  const flowElement = document.querySelector('.react-flow') as HTMLElement;

  if (flowElement) {
    try {
      const dataUrl = await toPng(flowElement, {
        backgroundColor: '#13111C',
        pixelRatio: 2,
        filter: (node) => {
          // Exclude controls and minimap from screenshot
          if (node?.classList?.contains('react-flow__controls')) return false;
          if (node?.classList?.contains('react-flow__minimap')) return false;
          return true;
        },
      });

      const response = await fetch(dataUrl);
      const imageBlob = await response.blob();
      zip.file(`${fileName}-graph.png`, imageBlob);
    } catch (err) {
      console.error('Failed to capture graph:', err);
    }
  }

  // 2. Add workflow file
  let content: string;
  if (fileExt === 'json') {
    content = JSON.stringify(workflowData, null, 2);
  } else if (fileExt === 'yaml' || fileExt === 'yml') {
    content = yaml.dump(workflowData);
  } else {
    content = typeof workflowData === 'string'
      ? workflowData
      : JSON.stringify(workflowData, null, 2);
  }
  zip.file(`${fileName}-workflow.${fileExt}`, content);

  // 3. Download ZIP
  const zipBlob = await zip.generateAsync({ type: 'blob' });
  const url = URL.createObjectURL(zipBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.zip`;
  link.click();
  URL.revokeObjectURL(url);
};